<template>
    <div class="customer-linked-accounts-actions">
        <v-card class="mb-2">
            <v-card-text v-if="!masterdataCeleraOne.loading">
                <div class="title">{{ fullname }}</div>
                <div class="cla-subheading">
                    <span class="subheading font-weight-regular grey--text">{{ email }}</span>
                </div>
            </v-card-text>
            <v-card-text v-if="masterdataCeleraOne.loading">
                <v-container d-flex align-center justify-center>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <NavigationBack
                    class="mb-2"
                    :text="'Zurück'"
                    :tooltip="'Zurück zu den Benutzerdetails'" />
            </v-card-actions>
        </v-card>
        <LinkedAccountsSummary
                v-if="!linkedAccountsSummary.loading && (getAssigned() + getUnassigned() > 0)"
                :ssoId="ssoId"
                :showButton="false"
                :loading="linkedAccountsSummary.loading"
                :linkedAccounts="linkedAccountsSummary.data"
            />
    </div>
</template>
<script>
import {
    mapGetters,
    mapState,
} from 'vuex';
import NavigationBack from '@/components/NavigationBack.vue';
import LinkedAccountsSummary from '@/components/customer/LinkedAccountsSummary.vue';

export default {
    name: 'LinkedAccountsActions',
    components: {
        NavigationBack,
        LinkedAccountsSummary,
    },
    computed: {
        ...mapGetters(['isDeveloper']),
        ...mapGetters('customerLinkedAccounts', ['fullname', 'email']),
        ...mapState('customerLinkedAccounts', ['ssoId', 'masterdataCeleraOne', 'linkedAccounts', 'linkedAccountsSummary']),
    },
    methods: {
        getAssigned() {
            if (this.linkedAccountsSummary.data) {
                return this.linkedAccountsSummary.data.assigned;
            }
            return 0;
        },
        getUnassigned() {
            if (this.linkedAccountsSummary.data) {
                return this.linkedAccountsSummary.data.unassigned;
            }
            return 0;
        },
    },
};

</script>
<style scoped lang="scss">
    .customer-linked-accounts-actions {
        min-height: 50px;
        .v-card__actions{
            display: flex;
            flex-direction: column;
            .v-btn {
                margin: 0;
            }
        }
    }

    .customer-link-accounts,
    .navigation-back,
    .v-card__actions button.v-btn,
    .v-tooltip {
        width: 100%;
    }

</style>
